import { Injectable, inject } from '@angular/core';
import { ICustomWindow, WindowRefService } from '@sirius/common';

/* eslint-disable @typescript-eslint/no-explicit-any */

@Injectable({
    providedIn: 'root',
})
export class OptimizelyService {
    private _windowRef = inject(WindowRefService);

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }


    /*
        https://docs.developers.optimizely.com/web-experimentation/reference/activate
        index.html makes sure window['optimizely'] is always defined, so no need for defensive check before usage.
    */
    activate(): void {
        if (!this.Window) return;

        (this.Window as any)['optimizely'].push({
            type: 'activate',
        });
    }
}
